import { render, staticRenderFns } from "./SamplingOrderCreation.vue?vue&type=template&id=a6c92f4c&scoped=true&lang=html&"
import script from "./SamplingOrderCreation.vue?vue&type=script&lang=js&"
export * from "./SamplingOrderCreation.vue?vue&type=script&lang=js&"
import style0 from "./SamplingOrderCreation.vue?vue&type=style&index=0&id=a6c92f4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c92f4c",
  null
  
)

export default component.exports